<app-loading-screen></app-loading-screen>
<router-outlet></router-outlet>
<app-chat [urlChat]="global.urlChat" *ngIf="!global.isIframe"></app-chat>
